import { makeObservable, action, observable, runInAction } from "mobx";
import ApiService from "../services/ApiService.mjs";
import ErrorUtil from "../utils/ErrorUtil.mjs";
import { Loadable } from "./models/Loadable.mjs";
const BANKLINK_PAYMENT_DESCRIPTION_PREFIX_DEFAULT = "Makse";
const LANGUAGE_UPPERCASE_PREFIXES = {
  et: "EST",
  ru: "RUS",
  en: "ENG"
};
const INTERVAL_MS = 2e3;
class BanklinkStore {
  constructor(apiService, paymentStore) {
    this.apiService = apiService;
    this.paymentStore = paymentStore;
    makeObservable(this, {
      banklinks: observable,
      errorMakingPayment: observable,
      loadBanklinks: action.bound
    });
  }
  banklinks;
  errorMakingPayment = false;
  paymentStatusInterval;
  pollPaymentStatus(banklinkTransactionReference) {
    if (this.paymentStatusInterval) {
      return;
    }
    this.paymentStatusInterval = setInterval(() => this.getPaymentStatus(banklinkTransactionReference), INTERVAL_MS);
  }
  clearInterval() {
    if (!this.paymentStatusInterval) {
      return;
    }
    clearInterval(this.paymentStatusInterval);
    this.paymentStatusInterval = void 0;
  }
  async getPaymentStatus(banklinkTransactionReference) {
    try {
      const response = await this.apiService.getBanklinkV2PaymentStatus(banklinkTransactionReference);
      this.paymentStore.setPaymentStatus(response.status);
      this.paymentStore.paymentHasFinalStatus && this.clearInterval();
    } catch (error) {
      this.clearInterval();
      if (error.status === ApiService.NOT_FOUND) {
        this.paymentStore.setPaymentStatus("NOT_FOUND");
        return;
      }
      this.paymentStore.setPaymentStatus("ERROR");
    }
  }
  loadBanklinks(includeV2) {
    if (!this.banklinks) {
      this.banklinks = Loadable.toLoadable(this.apiService.getBanklinks(includeV2));
    }
  }
  directToBank(parameters) {
    const paymentParameters = {
      ...parameters,
      description: parameters.description || BANKLINK_PAYMENT_DESCRIPTION_PREFIX_DEFAULT,
      language: LANGUAGE_UPPERCASE_PREFIXES[parameters.language]
    };
    this.apiService.getBanklinkParameters(paymentParameters).then((response) => {
      this.apiService.goToBank(response.BANK_URL, response);
    }).catch((error) => {
      runInAction(() => this.errorMakingPayment = true);
      ErrorUtil.registerError(error);
    });
  }
  directToBankV2(request) {
    this.apiService.initiateV2Payment({
      ...request,
      description: request.description || BANKLINK_PAYMENT_DESCRIPTION_PREFIX_DEFAULT,
      language: LANGUAGE_UPPERCASE_PREFIXES[request.language]
    }).then((response) => {
      window.parent.location.href = response.redirectUrl;
    }).catch((error) => {
      runInAction(() => this.errorMakingPayment = true);
      ErrorUtil.registerError(error);
    });
  }
}
export {
  BanklinkStore as default
};
